import { Reducer } from 'redux';

import { Actions } from 'store/actions/hippa.action';
import {
  HIPPA_FORM_SUBMITTING,
  HIPPA_FORM_SUBMITTED,
  HIPPA_FORM_FAILED,
  HIPPA_FORM_RESET,
} from 'store/types/hippa.type';
import { RootReducerType } from './index';

export type State = {
  isSubmitting: boolean;
  error: string;
  success: string | null;
};
const initialState = {
  isSubmitting: false,
  error: '',
  success: '',
};

export const hippaReducer: Reducer<State, Actions> = (state = initialState, action) => {
  switch (action.type) {
    case HIPPA_FORM_SUBMITTING:
      return { ...state, isSubmitting: true, error: '', success: '' };
    case HIPPA_FORM_SUBMITTED:
      return { ...state, isSubmitting: false, success: action.success };
    case HIPPA_FORM_FAILED:
      return { ...state, isSubmitting: false, error: action.error };
    case HIPPA_FORM_RESET:
      return initialState;

    default:
      return state;
  }
};

export const hippaSelector = (state: RootReducerType) => state.hippa;
export default hippaReducer;

